import { GET_USER_RECIPE_BOX } from 'graphql/recipebox';

export function toggleRecipeInCache(userRecipeId, tag, recipeId) {
  return function update(
    cache,
    {
      data: {
        updateRecipeInBox: {
          userRecipe: { tags }
        }
      }
    }
  ) {
    const rb = cache.readQuery({
      query: GET_USER_RECIPE_BOX
    });

    const tagToBeAdded = tags.find(t => t.recipeTagId === tag.recipeTagId);

    const recipeBox = {
      ...rb.recipeBox,
      recipes: rb.recipeBox.recipes.map(recipe => {
        if (recipe.userRecipeId === userRecipeId) {
          return {
            ...recipe,
            tags
          };
        }
        return recipe;
      }),
      tags: rb.recipeBox.tags.map(t => {
        if (t.recipeTagId === tag.recipeTagId && !tagToBeAdded) {
          return {
            ...t,
            userRecipes: t.userRecipes.filter(
              r => r.recipeId !== parseInt(recipeId, 10)
            )
          };
        }
        if (t.recipeTagId === tag.recipeTagId && tagToBeAdded !== undefined) {
          return {
            ...t,
            userRecipes: [
              ...t.userRecipes,
              {
                recipeId: parseInt(recipeId, 10),
                __typename: t.userRecipes[0].__typename
              }
            ]
          };
        }
        return t;
      })
    };

    cache.writeQuery({
      query: GET_USER_RECIPE_BOX,
      data: {
        recipeBox
      }
    });
  };
}

export function createRecipeInCache(userRecipeId) {
  return function update(
    cache,
    {
      data: {
        createRecipeTags: { recipeTags }
      }
    }
  ) {
    const rb = cache.readQuery({
      query: GET_USER_RECIPE_BOX
    });
    const tags = [
      ...rb.recipeBox.tags,
      ...recipeTags.filter(
        t => !rb.recipeBox.tags.map(rbt => rbt.name).includes(t.name)
      )
    ];

    const recipeBox = {
      ...rb.recipeBox,
      recipes: rb.recipeBox.recipes.map(recipe => {
        if (recipe.userRecipeId === userRecipeId) {
          return {
            ...recipe,
            tags: [...recipe.tags, ...recipeTags]
          };
        }
        return recipe;
      }),
      tags
    };

    cache.writeQuery({
      query: GET_USER_RECIPE_BOX,
      data: {
        recipeBox
      }
    });
  };
}

export default { toggleRecipeInCache, createRecipeInCache };
